import * as React from 'react';
import cn from 'src/lib/cn';
import Loader from './Loader';

interface IProps {
  variant?: 'default' | 'danger';
  loading?: boolean;
}

const Button: React.FC<IProps & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  variant = 'default',
  loading = false,
  children,
  ...props
}) => {
  return (
    <button
      className={cn(`button`, {
        'button--danger': variant === 'danger',
        'button--loading': loading,
      })}
      {...props}
    >
      {loading && <Loader />}
      {children}
    </button>
  );
};

export default Button;
